import { FaCheck, FaTimes, FaGasPump } from 'react-icons/fa';
import '../styles/ConfirmacaoModal.css';

const ConfirmacaoModal = ({ show, onClose, onConfirm, litros, placa, veiculo }) => {
  if (!show) return null;

  return (
    <>
      <div className="confirmacao-modal-overlay" onClick={onClose}>
        <div className="confirmacao-modal-content" onClick={(e) => e.stopPropagation()}>
          <div className="confirmacao-modal-header">
            <div className="confirmacao-header-info">
              <FaGasPump className="confirmacao-icon" />
              <h2>Confirmar Abastecimento</h2>
            </div>
            <button className="confirmacao-close-btn" onClick={onClose}>
              <FaTimes />
            </button>
          </div>

          <div className="confirmacao-modal-body">
            <div className="confirmacao-message">
              <p>Por favor, confirme os dados do abastecimento:</p>
            </div>

            <div className="confirmacao-dados">
              <div className="confirmacao-dado-item">
                <span className="confirmacao-label">Veículo:</span>
                <span className="confirmacao-value">{placa || '-'}</span>
              </div>
              <div className="confirmacao-dado-item">
                <span className="confirmacao-label">Descrição:</span>
                <span className="confirmacao-value">{veiculo || '-'}</span>
              </div>
              <div className="confirmacao-dado-item">
                <span className="confirmacao-label">Quantidade:</span>
                <span className="confirmacao-value">{litros} Litros</span>
              </div>
            </div>

            <div className="confirmacao-aviso">
              <FaCheck className="aviso-icon" />
              <span>Após confirmar, o abastecimento será registrado no sistema.</span>
            </div>
          </div>

          <div className="confirmacao-modal-footer">
            <button className="confirmacao-btn-cancelar" onClick={onClose}>
              <FaTimes />
              <span>Cancelar</span>
            </button>
            <button className="confirmacao-btn-confirmar" onClick={onConfirm}>
              <FaCheck />
              <span>Confirmar</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmacaoModal;
